import { useState } from 'react';

import { useDialogContext } from '../../../contexts/DialogContext';
import { useRebuildPackageCache } from '../../../hooks/api/backfills/useRebuildPackageCache';
import LoaderButton from '../../generic/Button/LoaderButton';
import Card from '../../generic/Card/Card';
import LabeledCheckbox from '../../generic/Forms/LabeledCheckbox';
import Text from '../../generic/Text';
import type { Organization } from '../../../types';

export const FullOrganizationPackageCacheRebuildCard = ({ org }: { org: Organization }) => {
  const { mutate: rebuildCache, isPending } = useRebuildPackageCache();
  const { onConfirm } = useDialogContext();
  const [shouldReduceConcurrency, setShouldReduceConcurrency] = useState(false);
  const onButtonClick = () => {
    onConfirm({
      title: 'Rebuild Organization Package Cache',
      body: (
        <div>
          This will also <b>turn on</b> the package index page for this organization. Are you sure you want to rebuild
          organization package cache for {org.title}?
        </div>
      ),
      onConfirm: async () => {
        rebuildCache({
          organizationId: org.id,
          reduceConcurrency: shouldReduceConcurrency,
        });
      },
    });
  };

  return (
    <Card isFullWidth padding="medium">
      <Card.Header>Rebuild Organization Package Cache</Card.Header>
      <Card.Content>
        <Text.Paragraph>This will fully rebuild the package cache for your current organization.</Text.Paragraph>
        <Text.Paragraph>
          Please note that rebuilding cache for some organizations may take a while. However, your existing data
          will not be affected and there will be no loss of functionality. You can check the status of the cache in
          the Faktory UI or the OrganizationPackages table.
        </Text.Paragraph>
        <div className="margin-bottom-md">
          <LabeledCheckbox
            label="Reduce concurrency (Warning: This will significantly increase processing time. Only use it if the cache job fails consistently.)"
            isChecked={shouldReduceConcurrency}
            onChange={() => {
              setShouldReduceConcurrency(!shouldReduceConcurrency);
            }}
              />
        </div>
        <LoaderButton isLoading={isPending} onClick={onButtonClick}>
          Rebuild
        </LoaderButton>
      </Card.Content>
    </Card>
  );
};
